module.exports = __webpack_public_path__ + "static/media/empty.3466428c.svg";